import React, { useEffect, useRef, useState } from 'react';
import { LottiePlayer } from 'lottie-web';

import { useLocation, useNavigate } from 'react-router-dom';
import { LOCAL_STORAGE_KEYS } from 'app/shared/util/local-storage-keys';
import { Storage } from 'react-jhipster';
import loadingAnimationData from './animation/loading.json';
import loadingContrastAnimationData from './animation/loading_contrast.json';
import { AccessibilityContrastEnum } from 'app/shared/accessibility/accessibility.enum';
import { useAccessibility } from 'app/shared/accessibility/accessiblity.provider';

const Animation = () => {
  const { contrast } = useAccessibility();

  const ref = useRef<HTMLDivElement>(null);
  const [lottie, setLottie] = useState<LottiePlayer | null>(null);

  useEffect(() => {
    import('lottie-web').then(Lottie => setLottie(Lottie.default));
  }, []);

  useEffect(() => {
    if (lottie && ref.current) {
      const animation = lottie.loadAnimation({
        container: ref.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: contrast === AccessibilityContrastEnum.IMPAIRED ? loadingContrastAnimationData : loadingAnimationData,
      });

      return () => animation.destroy();
    }
  }, [lottie]);

  return <div className="loader-animation" ref={ref} />;
};

export const Loader = props => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (props.redirect) {
      setTimeout(() => {
        if (location.pathname !== '/login' && Storage.local.get(LOCAL_STORAGE_KEYS.PENDING_AUTHENTICATION)) {
          Storage.local.remove(LOCAL_STORAGE_KEYS.PENDING_AUTHENTICATION);
          navigate('/login');
        }
      }, 1000);
    }
  }, []);

  return (
    <div className="d-flex align-items-center justify-content-center fullscreen">
      <Animation />
    </div>
  );
};
